import { render, staticRenderFns } from "./body-tool.vue?vue&type=template&id=1c51ae54&scoped=true&"
import script from "./body-tool.vue?vue&type=script&lang=js&"
export * from "./body-tool.vue?vue&type=script&lang=js&"
import style0 from "./body-tool.vue?vue&type=style&index=0&id=1c51ae54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c51ae54",
  null
  
)

export default component.exports